import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, getUserId, setFirstBranch, setOrgId, setPer } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import api from '@/api/index';

/*
数组转成Obj对象
* */
function getObj(dictList, key) {
  var obj = {};
  if (dictList === null || dictList.length === 0) {
    return obj;
  }
  if (key === 'COMBINEDSEARCH') {
    dictList.forEach(function (ele) {
      if (ele.dictStatus === 'VALID') {
        obj[ele.dictCode] = getObj(ele.children);
      }
    });
  } else {
    dictList.forEach(function (ele) {
      obj[ele.dictCode] = ele.dictName;
    });
  }
  return obj;
}
var getMenuData = function getMenuData() {
  var menuArr = store.state.settings.menuArr;
  if (menuArr.length) return Promise.resolve();
  return api.getMenuInfo({
    userId: getUserId()
  }).then(function (res) {
    if (res.code !== '0000000000') return;
    var _res$result = res.result,
      resourceList = _res$result.resourceList,
      roleList = _res$result.roleList,
      user = _res$result.user,
      permissionList = _res$result.permissionList;
    store.dispatch('settings/changeSetting', {
      key: 'menuArr',
      value: resourceList
    });
    store.dispatch('settings/changeSetting', {
      key: 'roleTypeArr',
      value: roleList
    });
    store.dispatch('settings/changeSetting', {
      key: 'userinfo',
      value: user
    });
    setPer(permissionList);
    setOrgId(user.orgId);
    setFirstBranch(user.firstBranch);
  });
};
var restoreIframeUrl = function restoreIframeUrl(to) {
  var _path$split;
  // 从url中恢复iframeUrl 用于页面刷新时恢复iframe页面(在iframeTemp中处理)
  var path = window.decodeURIComponent(to.fullPath);
  var iframePath = (_path$split = path.split('iframePath=')) === null || _path$split === void 0 ? void 0 : _path$split[1];
  store.dispatch('settings/changeSetting', {
    key: 'iframeUrl',
    value: iframePath
  });
};
var restoreUrlNav = function restoreUrlNav(to) {
  var _findMenuItem;
  // 从url中恢复本地导航activeMenu 因为iframe导航可能会把本地导航覆盖
  var origin = window.location.origin;
  var path = origin + to.fullPath;
  var _store$getters$menuAr = store.getters.menuArr,
    menuArr = _store$getters$menuAr === void 0 ? [] : _store$getters$menuAr;
  var defaultActiveMenu = (_findMenuItem = findMenuItem(menuArr, path)) === null || _findMenuItem === void 0 ? void 0 : _findMenuItem.resourceId;
  // defaultActiveMenu && sessionStorage.setItem('defaultactivemenu', defaultActiveMenu);
  store.dispatch('settings/changeSetting', {
    key: 'index',
    value: defaultActiveMenu
  });
};
var findMenuItem = function findMenuItem(menuArr, path) {
  // 递归查找菜单项
  var _iterator = _createForOfIteratorHelper(menuArr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.path === path) return item;
      var foundItem = item.children && findMenuItem(item.children, path);
      if (foundItem) return foundItem;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
};
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var _to$query, iframePath, src, newPage, url, path, patpath, iframpath, matchedTitle, hasToken, res, dictGroupMap, hasGetUserInfo;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            NProgress.start();
            // get isIframe
            _to$query = to.query, iframePath = _to$query.iframePath, src = _to$query.src, newPage = _to$query.newPage; // set page title
            if ([iframePath, src, newPage].every(function (item) {
              return !item;
            })) {
              // iframe的页面title逻辑在iframe组件中处理 newPage的在下面
              document.title = getPageTitle(to.meta.title);
            }
            // determine whether the user has logged in
            if (!(to.query.newPage !== undefined)) {
              _context.next = 16;
              break;
            }
            url = '';
            path = to.fullPath;
            path = window.decodeURIComponent(to.fullPath);
            if (path.indexOf('menuPath') > -1) {
              path = path.split('menuPath=');
              // if (to.query.isHash === '1') {
              //   url = `${to.query.newPage}/${path[1]}`;
              // } else {
              url = to.query.newPage + path[1];
              // }
            } else {
              // url = to.query.newPage
              url = path.split('newPage=')[1];
            }
            patpath = path[1].split('?')[0].split('menuPath=');
            iframpath = patpath[0];
            matchedTitle = router.match(iframpath).meta.title;
            if (matchedTitle !== '404') {
              document.title = '智能合规平台';
            } else {
              document.title = '智能合规平台';
            }
            _context.next = 14;
            return store.dispatch('settings/changeSetting', {
              key: 'iframeUrl',
              value: url
            });
          case 14:
            _context.next = 17;
            break;
          case 16:
            restoreIframeUrl(to);
          case 17:
            if (!whiteList.includes(to.path)) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return", next());
          case 19:
            hasToken = getToken();
            if (!hasToken) {
              _context.next = 54;
              break;
            }
            if (!(to.path === '/login')) {
              _context.next = 25;
              break;
            }
            next({
              path: '/'
            });
            NProgress.done();
            return _context.abrupt("return");
          case 25:
            getMenuData().then(function () {
              if (!to.fullPath.includes('?iframePath=')) restoreUrlNav(to);
            });
            if (!(sessionStorage.getItem('dist_info') === null)) {
              _context.next = 34;
              break;
            }
            _context.next = 29;
            return api.getDict().catch(function (err) {
              return err;
            });
          case 29:
            res = _context.sent;
            if (!(res.code !== '0000000000')) {
              _context.next = 32;
              break;
            }
            return _context.abrupt("return");
          case 32:
            dictGroupMap = res.result.dictGroupMap.reduce(function (acc, ele) {
              acc[ele.key] = getObj(ele.value, ele.key);
              return acc;
            }, {});
            sessionStorage.setItem('dist_info', JSON.stringify(dictGroupMap));
          case 34:
            hasGetUserInfo = store.getters.name;
            if (!hasGetUserInfo) {
              _context.next = 39;
              break;
            }
            next();
            _context.next = 52;
            break;
          case 39:
            _context.prev = 39;
            _context.next = 42;
            return store.dispatch('user/getInfo');
          case 42:
            next();
            _context.next = 52;
            break;
          case 45:
            _context.prev = 45;
            _context.t0 = _context["catch"](39);
            _context.next = 49;
            return store.dispatch('user/resetToken');
          case 49:
            Message.error(_context.t0 || 'Has Error');
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          case 52:
            _context.next = 56;
            break;
          case 54:
            next('/login');
            NProgress.done();
          case 56:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[39, 45]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});